import styled from 'styled-components';
import {
  FontSizes,
  TextCheckbox,
} from '../../../common/typography/typography.styles';
import { CheckboxWrapper } from '../../../common/checkbox/checkbox.styles';

export const NonStandardPackagingContainer = styled.div`
  display: grid;
  gap: 0.4rem;

  ${CheckboxWrapper} {
    margin-bottom: 8px;
  }

  ${TextCheckbox} {
    margin-bottom: 0;
    font-size: ${FontSizes.medium};
    font-weight: 500;
    color: ${({ theme }) => theme.colors.baseColors.grey150};
  }

  .non-standard-packaging-hint {
    margin-left: 2.4rem;
    font-size: ${FontSizes.normal};
    line-height: 2rem;
    color: ${({ theme }) => theme.colors.baseColors.grey100};
  }

  .non-standard-packaging-skeleton-label {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    margin-bottom: 8px;
  }

  .non-standard-packaging-skeleton-text {
    flex: 1;
    max-width: 28rem;
  }

  .non-standard-packaging-skeleton-hint {
    max-width: 48rem;
  }
`;
